// Import model
import { DateRangeFieldOptions } from '../models/DateRangeFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)
import { DateRangePreset } from '../models/DateRangePreset';

// Import dependency serializers (for complex types)
import { DateRangePresetSerializer } from './DateRangePresetSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DateRangeFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class DateRangeFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a DateRangeFieldOptions instance
   */
  static deserialize(json: string): DateRangeFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DateRangeFieldOptions instance
   */
  static fromObject(obj: any): DateRangeFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DateRangeFieldOptions');
    }


    const instance: DateRangeFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      min: obj['Min'] as string | undefined,
      max: obj['Max'] as string | undefined,
      dateRangePreset: obj['DateRangePreset'] ? (obj['DateRangePreset'] as any[]).map((item: any) =>
        DateRangePresetSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DateRangeFieldOptions instances
   */
  static deserializeArray(json: string): DateRangeFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DateRangeFieldOptions instance to a JSON string
   */
  static serialize(instance: DateRangeFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DateRangeFieldOptions instance to a plain object
   */
  static toObject(instance: DateRangeFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'Min': instance.min,
      'Max': instance.max,
      'DateRangePreset': instance.dateRangePreset?.map((item: any) =>
        DateRangePresetSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of DateRangeFieldOptions instances to a JSON string
   */
  static serializeArray(instances: DateRangeFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
